import * as React from 'react';
import styled from 'styled-components';

export interface CourseInfoItem {
  title: string;
  icon: React.ReactElement;
}

export const Container = styled.div`
  min-width: 85px;
  padding: 17px 14px;
  border-radius: 10px;
  background: ${({theme}) => theme.colors.primary};
`;

const InfoIcon = styled.div`
  margin-bottom: 10px;
`;

const InfoTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
`;

/**
 * The returns course info item component
 * @param {any} props
 * @return {React.ReactElement}
 * @constructor
 */
export default function CourseInfoItem(
    props: CourseInfoItem,
): React.ReactElement {
  const {title, icon} = props;

  return (
    <Container>
      <InfoIcon>
        {icon}
      </InfoIcon>
      <InfoTitle>
        {title}
      </InfoTitle>
    </Container>
  );
}
